import React, { memo } from 'react';

import { ExtendedExaminersList } from './ExaminersStructure.types';
import ExaminersStructureElement from './ExaminersStructureElement/ExaminersStructureElement.component';

interface ExaminersStructureProps {
  element: ExtendedExaminersList | null;
  isFirst?: boolean;
}

const ExaminersStructure: React.FC<ExaminersStructureProps> = ({ element, isFirst = false }) => {
  if (!element) {
    return null;
  }

  return <ExaminersStructureElement examiner={element} isFirst={element.isCurrentUser ? false : isFirst} />;
};

export default memo(ExaminersStructure);
